/**
 * Sorting of media service images (entries with `name`, `addedAt` and `exif`). Always oldest first (by name:
 * A to Z), and ties keep the order they came in.
 */
export const CAPTURED = "CAPTURED";
export const ADDED = "ADDED";
export const NAME = "NAME";

export const SORTS = [CAPTURED, ADDED, NAME];
export const DEFAULT_SORT = CAPTURED;

// EXIF writes "2021:04:19 10:23:54" (no time zone)
const EXIF_DATE = /^(\d{4}):(\d{2}):(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/;

function time (value) {
    const t = Date.parse(value);
    return isNaN(t) ? null : t;
}

/** When the image was uploaded (ms), null if unknown. */
export function addedAt (image) {
    return time(image && image.addedAt);
}

/**
 * When the image was taken (ms): EXIF dateTimeOriginal, else when it was added, else null. The EXIF time has no
 * time zone and is read as UTC, so images are compared by what the camera showed.
 */
export function capturedAt (image) {
    const text = image && image.exif && image.exif.dateTimeOriginal;
    const match = typeof text === "string" ? EXIF_DATE.exec(text.trim()) : null;
    if (match) {
        const [year, month, day, hour, minute, second] = match.slice(1).map(Number);
        // 0000:00:00 00:00:00 is what some cameras write for "unknown"
        if (year > 0 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
            return Date.UTC(year, month - 1, day, hour, minute, second);
        }
    }
    return addedAt(image);
}

const byTime = (get) => (a, b) => {
    const x = get(a);
    const y = get(b);
    // images without a time last
    return x === y ? 0 : x === null ? 1 : y === null ? -1 : x - y;
};

const byName = (a, b) => String(a.name || "").localeCompare(String(b.name || ""), undefined, { numeric: true, sensitivity: "base" });

/** [images] sorted by [sort] (CAPTURED, ADDED or NAME) as a new array. */
export function sortImages (images, sort = DEFAULT_SORT) {
    const compare = sort === NAME ? byName : byTime(sort === ADDED ? addedAt : capturedAt);
    return (images || []).slice().sort(compare);
}
